export default __webpack_public_path__ + "static/media/spinner.9265e256.gif";